import type { ComponentTypeDictionary } from "@newxsystems/types";

import { AccordionBlock } from "../cms/components/blocks/AccordionBlock/AccordionBlock";
import { CallToActionBlock } from "../cms/components/blocks/CallToActionBlock/CallToActionBlock";
import { FeaturedTestimonialBlock } from "../cms/components/blocks/FeaturedTestimonialBlock/FeaturedTestimonialBlock";
import { FooterBlock } from "../cms/components/blocks/FooterBlock/FooterBlock";
import { FormBlock } from "../cms/components/blocks/FormBlock/FormBlock";
import { HeroBlock } from "../cms/components/blocks/HeroBlock/HeroBlock";
import { IconContentGridBlock } from "../cms/components/blocks/IconContentGridBlock/IconContentGridBlock";
import { ImageContentGridBlock } from "../cms/components/blocks/ImageContentGridBlock/ImageContentGridBlock";
import { ImageBlock } from "../cms/components/blocks/ImageBlock/ImageBlock";
import { LogoCloudBlock } from "../cms/components/blocks/LogoCloudBlock/LogoCloudBlock";
import { MegaMenuBlock } from "../cms/components/blocks/MegaMenuBlock/MegaMenuBlock";
import { SimpleHeroBlock } from "../cms/components/blocks/SimpleHeroBlock/SimpleHeroBlock";
import { StatsBlock } from "../cms/components/blocks/StatsBlock/StatsBlock";
import { TeamMemberGridBlock } from "../cms/components/blocks/TeamMemberGridBlock/TeamMemberGridBlock";
import { TestimonialGridBlock } from "../cms/components/blocks/TestimonialGridBlock/TestimonialGridBlock";
import { TextContentGridBlock } from "../cms/components/blocks/TextContentGridBlock/TextContentGridBlock";
import { TextMediaBlock } from "../cms/components/blocks/TextMediaBlock/TextMediaBlock";
import { VideoBlock } from "../cms/components/blocks/VideoBlock/VideoBlock";
import { WysiwygBlock } from "../cms/components/blocks/WysiwygBlock/WysiwygBlock";
// IMPORT COMPONENTS HERE

export const BlocksFactory: ComponentTypeDictionary = [
  {
    type: "accordion",
    component: AccordionBlock,
  },
  {
    type: "callToAction",
    component: CallToActionBlock,
  },
  {
    type: "featuredTestimonial",
    component: FeaturedTestimonialBlock,
  },
  {
    type: "footer",
    component: FooterBlock,
  },
  {
    type: "form",
    component: FormBlock,
  },
  {
    type: "hero",
    component: HeroBlock,
  },
  {
    type: "iconContentGrid",
    component: IconContentGridBlock,
  },
  {
    type: "imageContentGrid",
    component: ImageContentGridBlock,
  },
  {
    type: "image",
    component: ImageBlock,
  },
  {
    type: "logoCloud",
    component: LogoCloudBlock,
  },
  {
    type: "megaMenu",
    component: MegaMenuBlock,
  },
  {
    type: "simpleHero",
    component: SimpleHeroBlock,
  },
  {
    type: "stats",
    component: StatsBlock,
  },
  {
    type: "teamMemberGrid",
    component: TeamMemberGridBlock,
  },
  {
    type: "testimonialGrid",
    component: TestimonialGridBlock,
  },
  {
    type: "textContentGrid",
    component: TextContentGridBlock,
  },
  {
    type: "textMedia",
    component: TextMediaBlock,
  },
  {
    type: "video",
    component: VideoBlock,
  },
  {
    type: "wysiwyg",
    component: WysiwygBlock,
  },
  // DECLARE COMPONENTS HERE
];
